// extracted by mini-css-extract-plugin
module.exports = {"container":"eeb6c9d23e--container--giuhd","title":"eeb6c9d23e--title--S46lf","description":"eeb6c9d23e--description--IXF3U"};